import { type FC } from 'react';
import LockIcon from '@assets/img/icons/lock.svg?react';
import { getImage } from '@common/lib/images';
import { type FactoryTypeText } from '@common/types/factory';
import { Container } from '@components/ui/Container/container';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { styles } from './config';

interface WorkshopPreviewProps {
  name: FactoryTypeText;
}

const WorkshopPreview: FC<WorkshopPreviewProps> = ({ name }) => {
  const products = useAppSelector(
    (state) => state.workshop.nextToBuild?.products,
  );
  const characterImage = getImage({
    name,
    field: 'character',
  });

  return (
    <div className="relative flex items-center gap-1 mb-6">
      <Picture
        className={cn('absolute left-1/2 -translate-x-1/2', styles[name])}
        img={characterImage?.img}
        webp={characterImage?.webp}
        alt="character"
      />
      {products?.map(({ id, name }, index) => {
        const image = getImage({ name, field: 'icons' });

        return (
          <Container
            className="w-[5rem] min-w-[5rem] min-h-[5rem] h-[5rem] flex items-center justify-center"
            variant="black-60"
            key={id || index}
          >
            <Picture className="w-full h-full" img={image?.img} alt={name} />
          </Container>
        );
      })}
      {Array.from({ length: 4 - (products?.length || 0) }).map((_, index) => {
        const position = (products?.length || 0) + index;
        const lvl = position * 5;

        return (
          <Container
            className="w-[5rem] min-w-[5rem] min-h-[5rem] h-[5rem] flex items-center justify-center"
            variant="black-60"
            key={index}
          >
            <div className="flex flex-col items-center gap-2">
              <LockIcon className="w-6 h-6 shrink-0" />
              <StringXSmall
                weight="bold"
                className="!text-white"
              >{`lvl. ${lvl}`}</StringXSmall>
            </div>
          </Container>
        );
      })}
    </div>
  );
};

export { WorkshopPreview };
